import entityReducer from 'syft-acp-core/reducers/generators/entityReducer'
import * as entityTypes from 'syft-acp-core/reducers/generators/entities'
import types from './action-types'

export default entityReducer('managerCommissions', {
  [entityTypes.ENTITIES_FETCH_BEGIN]: types.ENTITIES_FETCH_BEGIN,
  [entityTypes.ENTITIES_FETCH_SUCCEEDED]: types.ENTITIES_FETCH_SUCCEEDED,
  [entityTypes.ENTITIES_FETCH_FAILED]: types.ENTITIES_FETCH_FAILED,
})
